/*!

=========================================================
* Central System - v1.0.0
=========================================================

* Coded by Aircode

=========================================================

*/

// reactstrap components
import { Button, Container, Row, Col } from "reactstrap";
import secureLocalStorage from "react-secure-storage";

const UserHeader = () => {
  const user = JSON.parse(secureLocalStorage.getItem("user"))

  return (
    <>
      <div
        className="header pb-8 pt-5 pt-lg-4 d-flex align-items-center"
        style={{
          minHeight: "600px",

          backgroundPosition: "center top",
        }}
      >
        {/* Mask */}
      
        {/* Header container */}
        <Container className="d-flex align-items-center" fluid>
          <Row>
            <Col lg="12" md="12">
              <h1 className="display-2 text-dark">Hello {user.name}!</h1>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default UserHeader;
